import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="tabs"
export default class extends Controller {
  static targets = ["trigger", "view"];

  connect() {
    this.#activateFirstView();
  }

  select(event) {
    this.#deactivateAllTriggers();
    this.#activate(event.target);

    this.#deactivateAllViews();
    this.#activateView(event.params.view);
  }

  selectByView(view){
    this.#deactivateAllTriggers();
    const target = this.triggerTargets.find((target)=>(
      target.dataset.tabsViewParam === view
    ))
    this.#activate(target);
    this.#deactivateAllViews();
    this.#activateView(view);
  }

  #activateFirstView() {
    this.#activate(this.triggerTarget);
    this.#activate(this.viewTarget);
  }

  #activateView(view) {
    this.viewTargets.forEach((viewTarget) => {
      if (viewTarget.dataset.tabsView === view) {
        this.#activate(viewTarget);
      }
    });
  }

  #activate(element) {
    element.classList.add("active");
  }

  #deactivate(element) {
    element.classList.remove("active");
  }

  #deactivateAllTriggers() {
    this.#deactivateAll(this.triggerTargets);
  }

  #deactivateAllViews() {
    this.#deactivateAll(this.viewTargets);
  }

  #deactivateAll(elements) {
    elements.forEach((element) => {
      this.#deactivate(element);
    });
  }
}
